import { forwardRef } from 'react'
import { cn } from '~/lib/utils'

export interface FormGridProps extends React.HTMLAttributes<HTMLDivElement> {
  columns?: 2 | 3
  gap?: 4 | 6 | 8
}

export const FormGrid = forwardRef<HTMLDivElement, FormGridProps>(
  ({ columns = 3, gap = 6, className, ...props }, ref) => {
    const gridClasses = cn(
      'grid',
      'grid-cols-1',
      columns === 2 ? 'lg:grid-cols-2' : 'lg:grid-cols-2 2xl:grid-cols-3',
      gap === 4 && 'gap-3 lg:gap-4',
      gap === 6 && 'gap-3 lg:gap-6',
      gap === 8 && 'gap-3 lg:gap-8',
      className
    )

    return <div ref={ref} className={gridClasses} {...props} />
  }
)

FormGrid.displayName = 'FormGrid'
